import { render, staticRenderFns } from "./Step15.vue?vue&type=template&id=54a75b73&scoped=true"
import script from "./Step15.vue?vue&type=script&lang=js"
export * from "./Step15.vue?vue&type=script&lang=js"
import style0 from "./Step15.vue?vue&type=style&index=0&id=54a75b73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a75b73",
  null
  
)

export default component.exports